// tourEvents.js — the DOM-decoupled contract between onboarding surfaces and the
// tour engine (built in parallel by another package). We only ever DISPATCH; the
// TourProvider mounted in AppShell listens for 'prime:start-tour' and runs the
// matching tour. If no engine is present (e.g. during parallel dev or in a unit
// test with no listener) the dispatch is a harmless no-op — nothing starts.

export const START_TOUR_EVENT = 'prime:start-tour';

/** Ask the tour engine to start a tour by id. Safe when no engine is mounted. */
export function startTour(tourId) {
  if (!tourId || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(START_TOUR_EVENT, { detail: { tourId } }));
}
